"use client";

export { GlobalError as default } from "@workspace/observability/browser/next";
